<div class="row">
  <div data-zid="mostChosenName" class="col-xl-9 col-md-10 text-start text-align-left margin-auto font-medium">
    <web-components-instrument-details-link [isin]="savingPlan.isin">
      {{ savingPlan.name }}
    </web-components-instrument-details-link>
  </div>
  <div data-zid="most-chosen-button" class="col-xl-3 col-md-2 d-flex justify-content-end">
    <div
      class="trade savings-plan cursor-pointer"
      [title]="'savings-plan.most-chosen.item.title' | transloco"
      [routerLink]="savingPlanMaskUrl + '/' + savingPlan.isin"
    >
      <svg class="icon icon-24">
        <use xlink:href="/assets/img/svgs/svgset.svg#pig" />
      </svg>
    </div>
  </div>
</div>
<hr class="less-margin" />
